import Service from "../../Services";

const SupportVenueHire = {
  namespaced : true,
  state : {
    form : {
      id : '',
      message : '',
      email : '',
      phone : '',
      is_reply : false,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
     state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id : '',
        message : '',
        email : '',
        phone : '',
        is_reply : false,
      }
    }
  },
  actions : {
    getData({commit},page){
      return Service.CustomerSupportAPI.getVenueHire(page);
    },
    showData({commit},id){
      return Service.CustomerSupportAPI.showVenueHire(id);
    },
    saveData({commit},{id,data}){
      if(id){
        return Service.CustomerSupportAPI.updateVenueHire(id,data);
      }else{
        return Service.CustomerSupportAPI.createVenueHire(data);
      }
    },
    deleteData({commit},id){
      return Service.CustomerSupportAPI.deleteVenueHire(id);
    },
    setFormData({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default SupportVenueHire
